import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { vi } from "./locales/viet-nam";
import { en } from "./locales/english";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
const resources = {
  vi: {
    translation: {
      ...vi,
    },
  },
  en: {
    translation: {
      ...en,
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "vi",
  debug: true,

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export default i18n;
